/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import InfoCircleRegular from './info-circle-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <InfoCircleRegular {...validProps} />;
}
SvgComponent.iconName = 'info-circle-regular';

export const InfoCircleRegularIcon = svgIconWrapper(SvgComponent);
